export const TRACK_PERCENTAGE = 50;
export const TRACK_SECONDS = 3;
export const ESC_KEYCODE = 27;
export const PAUSE_KEYCODES = [32, 75];
export const KEYCODE_ENTER = 13;
export const NUMPAD_ENTER = 176;
export const MAX_LANDING_PAGE_REPLY_LENGTH = 1000;
export const MAX_MESSAGE_TEMPLATE_TEXT_LENGTH = 300;
export const PLATFORM_REPLY_LENGTH = 1500;
